import React, { useEffect, useState } from "react";
import walletC from "../Assets/walletC.svg";
import qr from "../Assets/qr.jpeg";
import { othersWallet } from "../utils/mockup.js";
import { CgSpinner } from "react-icons/cg";
import { FiX, FiCopy, FiSearch } from "react-icons/fi";

const WalletConnectModal = ({ setWalletCn, setModal, setImportWallet }) => {
  const [active, setActive] = useState(1); // Default to QR Code tab
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const itemsPerPage = 12;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = searchResults.slice(indexOfFirstItem, indexOfLastItem);

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timeout);
  }, []);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(searchResults.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  const handleChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    const filteredData = othersWallet.filter((item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase()),
    );
    setSearchResults(filteredData);
  }, [searchTerm]);

  return (
    <section className="fixed inset-0 z-50 flex items-center justify-center p-4 font-sans sm:p-6 md:p-8 bg-black/80 backdrop-blur-sm">
      {/* Backdrop */}
      <div
        className="absolute inset-0 z-0"
        onClick={() => setWalletCn(false)}
      />

      {loading ? (
        <div className="relative z-10 flex flex-col items-center justify-center w-full max-w-[360px] md:max-w-[420px] bg-[#121318] border border-[#1e2029] rounded-3xl p-8 shadow-2xl h-80 space-y-4">
          <CgSpinner className="text-[#00c087] animate-spin" size={42} />
          <p className="text-sm font-medium text-gray-400">
            Initializing WalletConnect...
          </p>
        </div>
      ) : (
        <div className="relative z-10 w-full max-w-[360px] md:max-w-[460px] lg:max-w-[520px] bg-[#121318] rounded-3xl p-5 md:p-7 shadow-2xl overflow-hidden border border-[#1e2029] text-[#d1d4dc]">
          {/* TOP HEADER BAR */}
          <div className="flex items-center justify-between pb-4 border-b border-[#1c1e26]">
            <div className="flex items-center gap-2.5">
              <div className="w-7 h-7 md:w-8 md:h-8 rounded-lg bg-[#034aff] flex items-center justify-center p-1.5 shadow-sm">
                <img
                  src={walletC}
                  alt="WalletConnect"
                  className="object-contain w-full h-full filter brightness-0 invert"
                />
              </div>
              <span className="text-base font-bold tracking-tight text-white md:text-lg">
                WalletConnect
              </span>
            </div>

            <div className="flex items-center gap-2">
              {/* Copy Link Action */}
              <button
                onClick={() =>
                  navigator.clipboard?.writeText(window.location.href)
                }
                className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold text-gray-300 bg-[#1b1d26] hover:bg-[#232734] hover:text-white rounded-xl border border-[#262936] transition-colors"
              >
                <FiCopy size={13} />
                Copy Link
              </button>

              {/* Close Button */}
              <button
                onClick={() => setWalletCn(false)}
                className="flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded-xl bg-[#1b1d26] text-gray-400 hover:text-white hover:bg-[#232734] border border-[#262936] transition-colors"
                aria-label="Close modal"
              >
                <FiX size={18} />
              </button>
            </div>
          </div>

          {/* TAB NAVIGATION SWITCH */}
          <div className="pt-5 pb-3">
            <div className="flex p-1 bg-[#1b1d26] rounded-2xl border border-[#262936]">
              {[
                { name: "QR Code", id: 1 },
                { name: "Desktop", id: 2 },
              ].map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActive(tab.id)}
                  className={`flex-1 py-2 text-xs md:text-sm font-bold rounded-xl transition-all ${
                    active === tab.id
                      ? "bg-[#00c087] text-black shadow-sm"
                      : "text-gray-400 hover:text-white"
                  }`}
                >
                  {tab.name}
                </button>
              ))}
            </div>
          </div>

          {/* MAIN MODAL BODY */}
          <div className="space-y-4">
            {active === 1 ? (
              /* QR CODE TAB */
              <div className="flex flex-col items-center justify-center py-4 space-y-4">
                <div className="flex items-center justify-center p-4 bg-white border border-gray-200 shadow-sm rounded-3xl">
                  <img
                    src={qr}
                    alt="Scan QR Code"
                    className="object-contain w-44 h-44 md:w-56 md:h-56 lg:w-60 lg:h-60 rounded-xl"
                  />
                </div>
                <p className="max-w-xs text-xs font-medium text-center text-gray-400 md:text-sm">
                  Scan QR code with a WalletConnect compatible wallet app
                </p>
              </div>
            ) : (
              /* DESKTOP / ALL WALLETS LIST TAB */
              <div className="pt-1 space-y-3">
                {/* Search Bar */}
                <div className="relative">
                  <input
                    type="text"
                    value={searchTerm}
                    onChange={handleChange}
                    placeholder="Search wallets..."
                    className="w-full pl-10 pr-4 py-2.5 text-sm bg-[#1b1d26] border border-[#262936] rounded-2xl outline-none focus:border-[#00c087] focus:ring-1 focus:ring-[#00c087] transition-all text-white placeholder-gray-500"
                  />
                  <FiSearch
                    size={16}
                    className="text-gray-500 absolute left-3.5 top-3.5"
                  />
                </div>

                {/* Grid List */}
                <div className="grid grid-cols-3 sm:grid-cols-4 gap-2.5 max-h-[220px] md:max-h-[280px] lg:max-h-[320px] overflow-y-auto pr-1 py-1 custom-scrollbar">
                  {currentData.map((item) => (
                    <button
                      key={item.id}
                      onClick={() => {
                        setWalletCn(false);
                        setModal(false);
                        setImportWallet(true);
                      }}
                      className="flex flex-col items-center justify-center p-3 bg-[#1b1d26] hover:bg-[#232734] border border-[#262936] rounded-2xl transition-all active:scale-[0.97] group text-center space-y-2"
                    >
                      <div className="flex items-center justify-center w-10 h-10 p-1 overflow-hidden md:w-11 md:h-11 rounded-xl bg-[#121318] border border-[#262936]">
                        <img
                          src={item.icon}
                          alt={item.name}
                          className="object-contain w-full h-full rounded-full"
                        />
                      </div>
                      <span className="w-full text-xs font-semibold text-gray-300 truncate group-hover:text-white">
                        {item.name}
                      </span>
                    </button>
                  ))}
                </div>

                {/* Pagination Controls */}
                {pageNumbers.length > 1 && (
                  <div className="flex items-center justify-center gap-1.5 pt-2">
                    {pageNumbers.map((number) => (
                      <button
                        key={number}
                        onClick={() => handlePageChange(number)}
                        className={`w-7 h-7 text-xs font-bold rounded-lg transition-colors ${
                          number === currentPage
                            ? "bg-[#00c087] text-black shadow-xs"
                            : "bg-[#1b1d26] text-gray-400 hover:text-white hover:bg-[#232734] border border-[#262936]"
                        }`}
                      >
                        {number}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default WalletConnectModal;
